import { Badge } from '@moda/om';
import React, { FC } from 'react';
import { CollectionBadgeType, useCollectionBadges } from '../../hooks/useCollectionBadges';

interface Props {
  collections: (string | null)[];
  type: CollectionBadgeType;
}

export const CollectionBadge: FC<Props> = ({ collections, type = CollectionBadgeType.Default }) => {
  const collection = useCollectionBadges(collections, type);

  if (!collection) return null;

  return (
    <Badge className="CollectionBadge" theme={collection.theme}>
      {collection.message}
    </Badge>
  );
};
